import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  questionContainer: {
    width: "40%",
    border: "5px solid #003E4C",
    padding: "25px 10px 15px 30px",
    // margin: "100px 10px 0px 40px",
    backgroundColor: "#fff",
    [emulatorScreen(theme)]: {
      // width: "210px",
      border: "4px solid #003E4C",
      padding: "15px 10px 15px 20px",
      // margin: "70px 38px 0px 25px",
    },
    [mobileScreen(theme)]: {
      // width: "183px",
      border: "4px solid #003E4C",
      // margin: "30px 38px 0px 62px",
      padding: "5px 13px 5px 16px",
    },
  },

  questionBody: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },

  breakingNews: {
    position: "absolute",
    top: "-60px",
    left: "-80px",
    height: "60px",
    [emulatorScreen(theme)]: {
      top: "-40px",
      left: "-50px",
      height: "36px",
    },
    [mobileScreen(theme)]: {
      top: "-22px",
      left: "-43px",
      height: "24px",
    },
  },

  circleIcon: {
    position: "absolute",
    top: "-86px",
    right: "-65px",
    height: "110px",
    [emulatorScreen(theme)]: {
      top: "-48px",
      right: "-46px",
      height: "65px",
    },
    [mobileScreen(theme)]: {
      top: "-30px",
      right: "-35px",
      height: "40px",
    },
  },

  questionText: {
    color: "#515151",
    fontWeight: "400",
    paddingTop: "12px",
    paddingRight: "15px",
    fontSize: "21px",
    fontFamily: "'Oswald', sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: "14px",
      paddingTop: 5,
      paddingRight: 10
    },
    [mobileScreen(theme)]: {
      fontSize: "12px",
      paddingTop: 4,
    },
  },

  subQuestionText: {
    color: "#003E4D",
    fontWeight: "500",
    paddingTop: "20px",
    paddingRight: "15px",
    fontSize: "25px",
    fontFamily: "'Oswald', sans-serif",
    [emulatorScreen(theme)]: {
      fontSize: "15px",
    },
    [mobileScreen(theme)]: {
      fontSize: "13px",
      paddingTop: "8px",
    },
  },
});
export default styles;
